import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";

import { useGetInventoryManagersList } from "../apis";

const useInventoryManagersList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    showDeletedOnly,
    setShowDeletedOnly,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id,
      isDeleted: showDeletedOnly,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
    }),
    [page, debouncedSearch, sorting, showDeletedOnly]
  );

  const {
    inventoryManagersList,
    meta,
    isLoading,
    refetch: refetchInventoryManagers
  } = useGetInventoryManagersList(requestParams);

  return {
    inventoryManagersList,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    showDeletedOnly,
    setShowDeletedOnly,
    setSorting,
    setSearchValue,
    setPage,
    refetchInventoryManagers
  };
};

export default useInventoryManagersList;
